import { useToken } from '../App'
// import { makeStyles, Typography } from '@material-ui/core'
import { Redirect, Route, Switch } from 'react-router-dom'
// import { SignIn } from './SignIn'
// import { SignUp } from './SignUp'
// import { ForgotPassword } from './ForgotPassword'
import { SignOut } from './SignOut'
// import logo from '../assets/images/raymandlogo.png'
import NavigateSignin from './NavigateSignin'
import { strings } from 'strings'

export function Entrance() {
  // const classes = useStyles()

  // const title =
  //   JSON.parse(localStorage.getItem('config') ?? '{}')?.APP_TITLE ||
  //   'سامانه تعیین موقعیت آنی سحاب'

  return (
    <div>
      <p>{strings.landingLoading}</p>
      <Switch>
        <Route path="/auth/signin" component={NavigateSignin} />
        {/* <Route path="/auth/signup" component={SignUp} /> */}
        {/* <Route path="/auth/forgot" component={ForgotPassword} /> */}
        <Route path="/auth/signout" component={SignOut} />
        <Redirect to="/auth/signin" />
      </Switch>
      <EntranceForAuth />
    </div>
  )
}

function EntranceForAuth() {
  const { ut: userRole } = useToken()

  switch (userRole) {
    case 'admin':
    case 'operator':
      return <Redirect to="/" />
    case 'regular':
      return <Redirect to="/verify" />
    default:
      return null
  }
}

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       v20250820
//     </Typography>
//   )
// }

// const useStyles = makeStyles((theme) => ({
//   layout: {
//     width: 480,
//     marginLeft: 'auto',
//     marginRight: 'auto',
//     [theme.breakpoints.down('xs')]: {
//       width: 'auto',
//       margin: theme.spacing(0, 2),
//     },
//   },
//   paper: {
//     margin: theme.spacing(2, 0),
//     padding: theme.spacing(2),
//   },
// }))
